const WEHITELABEL_INFO_LOADED = 'WEHITELABEL_INFO_LOADED';
const WEHITELABEL_INFO_NOT_FOUND = 'WEHITELABEL_INFO_NOT_FOUND';

export { WEHITELABEL_INFO_LOADED, WEHITELABEL_INFO_NOT_FOUND };